import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { downloadFile, postAction } from '@/api/manage';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryStandardTreeList, queryUserTreeList } from '@/api/api';
export default {
  name: 'DayWasteGasReportModal',
  mixins: [JeecgListMixin],
  data: function data() {
    return {
      standardList: [],
      drawerVisible: false,
      userTree: [],
      reportObj: {},
      userId: [],
      tableArr: [],
      statisticState: false,
      detailState: false,
      url: {
        add: '/om/day/waste/gas/report/add',
        edit: '/om/day/waste/gas/report/edit',
        exportXlsUrl: '/om/day/waste/gas/report/exportXls'
      }
    };
  },
  watch: {
    drawerVisible: function drawerVisible(value) {
      if (!value) {
        this.reportObj = {};
        this.userId = [];
        this.statisticState = false;
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    // this.getStandard()
    this.getUser();
  },
  methods: {
    handleExportXls: function handleExportXls(fileName) {
      var that = this;

      if (that.reportObj.id) {
        that.queryParam.id = that.reportObj.id;
      }

      if (that.reportObj.userId) {
        that.queryParam.userId = that.reportObj.userId;
      }

      if (!fileName || typeof fileName != 'string') {
        fileName = that.pageTitle + '导出文件';
      }

      var param = _objectSpread({}, that.queryParam);

      if (that.selectedRowKeys && that.selectedRowKeys.length > 0) {
        param['selections'] = that.selectedRowKeys.join(',');
      }

      var url = that.url && that.url.exportXlsUrl ? that.url.exportXlsUrl : that.pagePath + '/exportXls';
      downloadFile(fileName + '.xls', url, param);
    },
    onToGenerate: function onToGenerate() {
      var _this = this;

      postAction('/om/day/waste/gas/report/generateStatistics', this.reportObj).then(function (res) {
        if (res.success) {
          _this.statisticState = true;
          _this.reportObj.statistics = res.result;
        }
      });
    },
    onToDelete: function onToDelete(item, index) {
      var _this2 = this;

      this.$confirm({
        title: '提示',
        content: '确定要删除站点' + item.siteName + '的烟气日报?',
        onOk: function onOk() {
          _this2.tableArr.splice(index, 1);
        },
        onCancel: function onCancel() {}
      });
    },
    getUser: function getUser() {
      var _this3 = this;

      // 用户
      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];

            _this3.userTree.push(temp);
          }
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      this.$confirm({
        title: '提示',
        content: '确定保存并推送',
        onOk: function onOk() {
          _this4.reportObj['pushUser'] = _this4.userId.length > 0 ? _this4.userId.join(',') : '';
          postAction('/om/day/waste/gas/report/addPush', _this4.reportObj).then(function (res) {
            if (res.success) {
              _this4.drawerVisible = false;

              _this4.$parent.getOperationList();
            }
          });
        }
      });
    },
    onClose: function onClose() {
      this.drawerVisible = false;
    }
  }
};